import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CandidateComponent } from './candidate.component';
import { AccountCandidateEditComponent } from './components/account-candidate-edit/account-candidate-edit.component';
import { AuthLoginCandidateGuard } from './services/auth-login-candidate.guard';

// Curriculum
import { CandidateHvComponent } from './components/candidate-hv/candidate-hv.component';

// Vacancies
import { CandidateVacanciesComponent } from './components/candidate-vacancies/candidate-vacancies.component';

// Applications
import { CandidateApplicationsComponent } from './components/candidate-applications/candidate-applications.component';

// disabilities
// import { CandidateDisabilitiesComponent } from './components/candidate-disabilities/candidate-disabilities.component';
import { CandidateDisabilitiesComponent } from '../disability/components/candidate-disabilities/candidate-disabilities.component';
import { NewCandidateDisabilitieComponent } from '../disability/components/candidate-disabilities/new-candidate-disabilitie/new-candidate-disabilitie.component';

const routes: Routes = [
  // { path: '', redirectTo: 'login-candidate', pathMatch: 'full' },
  // { path: 'login', component: LoginComponent },
  // { path: 'login-candidate', component: LoginCandidateComponent },
  // { path: '**', redirectTo: 'login-candidate', pathMatch: 'full' },

  {
    path: 'candidate',
    component: CandidateComponent,
    canActivate: [AuthLoginCandidateGuard],
    data: {
      role: ['Candidate', 'Candidate Synergo']
    },
    children: [
      { path: '', redirectTo: 'curriculum', pathMatch: 'full' },
      { path: 'account', component: AccountCandidateEditComponent },
      { path: 'curriculum', component: CandidateHvComponent },
      { path: 'vacancies', component: CandidateVacanciesComponent },
      { path: 'applications', component: CandidateApplicationsComponent },
      { path: 'disabilities', component: CandidateDisabilitiesComponent },
      { path: 'disabilities/:id', component: NewCandidateDisabilitieComponent },
      { path: '**', redirectTo: 'curriculum', pathMatch: 'full' },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CandidateRoutingModule { }



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/candidate-routing.module.ts